import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
export default function Pagination({ currentPage = 1, totalPages = 1, onPageChange, maxVisiblePages = 5, totalEntries, itemsPerPage = 10, showEntriesMessage = true, showControls = true, }) {
    if (totalEntries === 0 || (totalEntries === undefined && totalPages <= 1))
        return null;
    // Calculate entries message
    const getEntriesMessage = () => {
        if (!showEntriesMessage || totalEntries === undefined)
            return null;
        const startEntry = (currentPage - 1) * itemsPerPage + 1;
        const endEntry = Math.min(currentPage * itemsPerPage, totalEntries);
        return `Showing ${startEntry} to ${endEntry} of ${totalEntries} entries`;
    };
    const entriesMessage = getEntriesMessage();
    const handlePrevious = () => {
        if (currentPage > 1 && onPageChange) {
            onPageChange(currentPage - 1);
        }
    };
    const handleNext = () => {
        if (currentPage < totalPages && onPageChange) {
            onPageChange(currentPage + 1);
        }
    };
    const handlePageClick = (page) => {
        if (onPageChange && page !== currentPage) {
            onPageChange(page);
        }
    };
    // Calculate which page numbers to show
    const getVisiblePages = () => {
        const pages = [];
        const halfVisible = Math.floor(maxVisiblePages / 2);
        let startPage = Math.max(1, currentPage - halfVisible);
        let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
        // Adjust start if we're near the end
        if (endPage - startPage < maxVisiblePages - 1) {
            startPage = Math.max(1, endPage - maxVisiblePages + 1);
        }
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }
        // Add ellipsis if needed
        if (startPage > 1) {
            if (startPage > 2) {
                pages.unshift("...");
            }
            pages.unshift(1);
        }
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                pages.push("...");
            }
            pages.push(totalPages);
        }
        return pages;
    };
    const visiblePages = getVisiblePages();
    const isPreviousDisabled = currentPage === 1;
    const isNextDisabled = currentPage === totalPages;
    return (_jsxs(Box, { className: "pagination-container", children: [entriesMessage && (_jsx(Box, { className: "pagination-entries-message", children: _jsx(Typography, { className: "pagination-entries-text", sx: { fontSize: '14px !important', fontWeight: '500 !important' }, children: entriesMessage }) })), showControls && (_jsxs(Box, { className: "pagination-controls", children: [_jsx(Box, { className: "pagination-button-wrapper", children: _jsxs(Box, { component: "button", className: `pagination-nav-button ${isPreviousDisabled ? "pagination-nav-button-disabled" : ""}`, onClick: handlePrevious, disabled: isPreviousDisabled, children: [_jsx("svg", { width: "16", height: "16", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M15.8332 10.0001H4.1665M4.1665 10.0001L9.99984 15.8334M4.1665 10.0001L9.99984 4.16675", stroke: "#414651", strokeWidth: "1.67", strokeLinecap: "round", strokeLinejoin: "round" }) }), _jsx(Typography, { className: "pagination-nav-text", sx: { fontSize: '14px !important', fontWeight: '500 !important' }, children: "Previous" })] }) }), _jsx(Box, { className: "pagination-numbers", children: visiblePages.map((page, index) => {
                            if (page === "...") {
                                return (_jsx(Box, { className: "pagination-number-base", children: _jsx(Box, { className: "pagination-number-content", children: _jsx(Typography, { className: "pagination-number-text-ellipsis", sx: { fontSize: '14px !important', fontWeight: '500 !important' }, children: "..." }) }) }, `ellipsis-${index}`));
                            }
                            const isActive = page === currentPage;
                            const pageNum = page;
                            return (_jsx(Box, { className: `pagination-number-base ${isActive ? "pagination-number-active" : ""}`, onClick: () => handlePageClick(pageNum), children: _jsx(Box, { className: "pagination-number-content", children: _jsx(Typography, { className: `pagination-number-text ${isActive ? "pagination-number-text-active" : ""}`, sx: { fontSize: '14px !important', fontWeight: '500 !important' }, children: page }) }) }, page));
                        }) }), _jsx(Box, { className: "pagination-button-wrapper", children: _jsxs(Box, { component: "button", className: `pagination-nav-button ${isNextDisabled ? "pagination-nav-button-disabled" : ""}`, onClick: handleNext, disabled: isNextDisabled, children: [_jsx(Typography, { className: "pagination-nav-text", sx: { fontSize: '14px !important', fontWeight: '500 !important' }, children: "Next" }), _jsx("svg", { width: "16", height: "16", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: _jsx("path", { d: "M4.167 10h11.666m0 0L10 4.167M15.833 10 10 15.833", stroke: "#414651", strokeWidth: "1.67", strokeLinecap: "round", strokeLinejoin: "round" }) })] }) })] }))] }));
}
